import { Form, Radio } from "antd";
import { useField } from "formik";

function RadioGroup({ name, Item, ...rest }) {
  const [field, meta, helpers] = useField(name);

  const config = { ...field, ...rest };

  if (meta && meta.touched && meta.error) {
    config.error = true;
    config.helperText = meta.error;
  }

  const handleChangeSelect = (value) => {
    helpers.setValue(value);
    helpers.setError("");
    helpers.setTouched(false);
  };

  return (
    <Form.Item
      className="mb-0"
      label={rest?.label}
      help={meta.error && meta?.error && meta?.touched ? meta.error : ""}
      validateStatus={config.error ? "error" : "success"}
    >
      <Radio.Group defaultValue={1} className="mb-lg-2" {...field} {...rest}>
        {Item.map((item, index) => {
          return item?.text ? (
            <Radio
              key={index}
              id={item?.id}
              value={item?.id}
              onChange={handleChangeSelect}
            >
              <span className="labelTitle d-block">{item?.name}</span>{" "}
              <p className="labelPara mb-0">({item?.text})</p>
            </Radio>
          ) : (
            <Radio
              key={index}
              id={item?.id}
              value={item?.id}
              onChange={handleChangeSelect}
            >
              {item?.name}
            </Radio>
          );
        })}
      </Radio.Group>
    </Form.Item>
  );
}

export default RadioGroup;
